import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames/bind';
import Icon from '../../elementals/icon';
import Popup from '../../overlays/popup';
import TagDropdown from '../../elementals/tagDropdown';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const renderEditIcon = (propertyId, photoId) => {
    const active = _.every([propertyId, photoId], Boolean);
    const renderTrigger = () => (_jsx(Icon, { "data-elm-id": 'edit_icon', name: 'pencil-alt', style: { fontSize: 16, cursor: 'pointer' }, iconStyle: 'solid', disabled: !active, fitted: true, color: 'grayLight', className: 'u-pr-1', hoverColor: active ? 'adcLightBlue' : '', onClick: () => {
            window.location.assign(`/trinity/property/${propertyId}/photos/${photoId}/edit`);
        } }));
    return (_jsx(Popup, { content: 'Please save this newly uploaded photo first', trigger: renderTrigger(), style: { left: -12 }, disabled: active }));
};
const formatDate = dateString => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return dateString
        ? new Date(dateString).toLocaleDateString(undefined, options)
        : '';
};
const PhotoCard = ({ id, tag, title, createdOn, updatedOn, ribbon, isSelected, onDelete, onUndelete, onDoubleClick, onTagChange, photoUrl, photoId, propertyId, disableTag, showPhotoOnly, allowEditing, allowTagging, }) => {
    return (_jsxs("div", { "data-elm-id": 'photo_card', className: cx('card', {
            'photo-only': showPhotoOnly,
        }), children: [!showPhotoOnly && (_jsx("div", { className: cx('header'), children: _jsxs("div", { className: cx('row'), children: [_jsx("div", { "data-elm-id": 'title', children: _jsx("strong", { children: title }) }), _jsxs("div", { children: [isSelected &&
                                    allowEditing &&
                                    renderEditIcon(propertyId, photoId), _jsx(Icon, { "data-elm-id": 'delete_icon', style: { fontSize: 16, cursor: 'pointer' }, iconStyle: 'solid', name: isSelected ? 'trash' : 'trash-undo', fitted: true, color: 'grayLight', hoverColor: isSelected ? 'error' : 'success', onClick: () => {
                                        isSelected ? onDelete(id) : onUndelete(id);
                                    } })] })] }) })), _jsxs("div", { style: {
                    backgroundImage: `url(${photoUrl})`,
                }, "data-elm-id": 'photo', className: cx('photo', showPhotoOnly && ['photo-only']), onDoubleClick: () => {
                    onDoubleClick(id);
                }, children: [_jsx("div", { className: cx('ribbon-container'), children: ribbon }), allowTagging && !showPhotoOnly && (_jsx("div", { className: cx('row', 'bottom-right-box'), children: _jsx("div", { className: cx('tag-dropdown'), children: _jsx(TagDropdown, { tag: tag, size: 'tiny', onTagChange: onTagChange(id), disabled: disableTag, elmId: `photo_card_tag_dropdown_${id}` }) }) }))] }), showPhotoOnly && createdOn && onDelete && (_jsx("div", { className: cx('footer'), children: _jsxs("div", { className: cx('row'), children: [_jsxs("div", { className: cx('footer-subtitle'), "data-elm-id": 'created-on', children: ["Uploaded: ", _jsx("span", { children: formatDate(createdOn) })] }), _jsx(Icon, { "data-elm-id": 'delete_icon', style: { fontSize: 16, cursor: 'pointer' }, iconStyle: 'solid', name: isSelected ? 'trash' : 'trash-undo', fitted: true, color: 'errorLight', hoverColor: isSelected ? 'error' : 'success', onClick: () => {
                                isSelected ? onDelete(id) : onUndelete(id);
                            }, className: cx('delete-icon', { selected: isSelected }) })] }) })), !showPhotoOnly && (_jsxs("div", { className: cx('footer'), children: [_jsx("div", { className: cx('row'), children: _jsxs("div", { className: cx('footer-subtitle'), "data-elm-id": 'created-on', children: ["Uploaded: ", _jsx("span", { children: formatDate(createdOn) })] }) }), _jsx("div", { className: cx('row'), children: _jsxs("div", { className: cx('footer-subtitle'), "data-elm-id": 'updated-on', children: ["Last Update:", ' ', _jsx("span", { children: updatedOn ? formatDate(updatedOn) : formatDate(createdOn) })] }) })] }))] }, id));
};
PhotoCard.defaultProps = {
    title: '',
    tag: '',
    createdOn: '',
    updatedOn: '',
    ribbon: undefined,
    onDelete: _.noop,
    onUndelete: _.noop,
    onTagChange: _.noop,
    onDoubleClick: _.noop,
    photoUrl: '',
    photoId: '',
    propertyId: '',
    disableTag: false,
    showPhotoOnly: false,
    allowEditing: true,
    allowTagging: true,
};
PhotoCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isSelected: PropTypes.bool.isRequired,
    title: PropTypes.string,
    tag: PropTypes.string,
    createdOn: PropTypes.string,
    updatedOn: PropTypes.string,
    ribbon: PropTypes.node,
    onDelete: PropTypes.func,
    onUndelete: PropTypes.func,
    onTagChange: PropTypes.func,
    onDoubleClick: PropTypes.func,
    photoUrl: PropTypes.string,
    photoId: PropTypes.string,
    propertyId: PropTypes.string,
    disableTag: PropTypes.bool,
    showPhotoOnly: PropTypes.bool,
    allowEditing: PropTypes.bool,
    allowTagging: PropTypes.bool,
};
export default PhotoCard;
//# sourceMappingURL=index.js.map